import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export interface IWFNXSmallCardFooterProps {
  className?: string;
}

export class WFNXSmallCardFooter extends React.Component<React.PropsWithChildren<IWFNXSmallCardFooterProps>, any> {
  static propTypes = {
    className: PropTypes.string
  };

  render() {
    const { className } = this.props;

    return (
      <div className={classNames('wfnx-small-card-footer', className)}>
        {this.props.children}
      </div>
    );
  }
}
